
export default {
  name: "Portfolio",
  props: ["portfolioData", "recommData","is_premium","imgPath"],
  data(){
    return{
      modalShow: false
    }
  },
  computed: {
    isARGuest() {
      return localStorage.getItem('userType') == 3? true:false;
    }
  },

  methods: {

    getTwoFixedVal(value) {
      if (
        isNaN(value) ||
        value == 0 ||
        value == "-" ||
        value == null ||
        value == ""
      ) {
        return "-";
      } else {
        return parseFloat(value).toFixed(2);
      }
    },

    redirecttoplanpage(){
      this.$router.push('plandetails')
    },

    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/Report/Recommendations.js